import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import '../styles/achievements/Achievements.min.css';
import stat1 from '../images/stat1.svg';
import stat2 from '../images/stat2.svg';
import stat3 from '../images/stat3.svg';

const Achievements = () => {
    const { ref, inView } = useInView({
        triggerOnce: true, // Анімація запускається лише один раз
        threshold: 0.3,   // Запуск при 30% видимості
    });

    return (
        <div className='achievements-bg section-separator mb-0' ref={ref}>
            <Container className="stats-section text-center achievements-bg">
                <Row className='achievements-bg py-3 d-flex align-items-center'>
                    {/* Блок 1: Jovens Impactados */}
                    <Col md={4} className="stat-item achievements-bg">
                        <img src={stat1} className='achievements-bg mb-3' alt="Stat 1" />
                        <h2 className='achievements-bg fw-bold display-5'>
                            {inView && <CountUp start={0} end={12000} duration={3} separator="," className='achievements-bg fw-bold display-5'/>} +
                        </h2>
                        <p className='achievements-bg'>Jovens<br />Impactados</p>
                    </Col>

                    {/* Блок 2: Atividades Organizadas */}
                    <Col md={4} className="stat-item achievements-bg">
                        <img src={stat2} className='achievements-bg mb-3' alt="Stat 2" />
                        <h2 className='achievements-bg fw-bold display-5'>
                            {inView && <CountUp start={0} end={50} duration={2.5} className='achievements-bg fw-bold display-5' />} +
                        </h2>
                        <p className='achievements-bg'>Atividades<br />Organizadas</p>
                    </Col>

                    {/* Блок 3: Intercâmbios Realizados */}
                    <Col md={4} className="stat-item achievements-bg">
                        <img src={stat3} className='achievements-bg mb-3' alt="Stat 3" />
                        <h2 className='achievements-bg fw-bold display-5'>
                            {inView && <CountUp start={0} end={10} duration={2} className='achievements-bg fw-bold display-5' />} +
                        </h2>
                        <p className='achievements-bg'>Intercâmbios<br />Realizados</p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Achievements;
